/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithLinks_shoppingWith = {
    readonly links: {
        readonly title: string | null;
        readonly links: ReadonlyArray<{
            readonly url: string | null;
            readonly label: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ShoppingWithLinks_shoppingWith";
};
export type ShoppingWithLinks_shoppingWith$data = ShoppingWithLinks_shoppingWith;
export type ShoppingWithLinks_shoppingWith$key = {
    readonly " $data"?: ShoppingWithLinks_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithLinks_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithLinks_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "links",
      "storageKey": null,
      "args": null,
      "concreteType": "ShoppingWithLinks",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "links",
          "storageKey": null,
          "args": null,
          "concreteType": "ShoppingWithLink",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e776fb080bd7a52e41ac72b94930c6f9';
export default node;
